import React from 'react';
import { Cloud, Repeat, ShieldCheck, Globe, Infinity, CheckCircle2 } from 'lucide-react';
import './WebsiteDevelopment.css';
import Hero from '../../components/Hero/Hero';
import FAQ from '../../components/FAQ/FAQ';
import CTASection from '../../components/CTA/CTA';
import Footer from '../../components/Footer/Footer';

export default function DeploymentRenewals() {
  const features = [
    {
      icon: <Cloud size={24} />,
      title: 'Cloud Deployment',
      text: 'Deploying your site on optimized cloud infrastructure for maximum uptime and speed.'
    },
    {
      icon: <Repeat size={24} />,
      title: 'Managed Renewals',
      text: 'Automated management of your domains, SSL certificates, and hosting packages.'
    },
    {
      icon: <ShieldCheck size={24} />,
      title: 'Enterprise SSL',
      text: 'Ensuring your security certificates are always valid and follow modern encryption standards.'
    }
  ];

  const faqItems = [
    {
      question: 'What hosting providers do you use?',
      answer: 'We deploy primarily on AWS, Azure, and high-performance managed Vercel or WP-Engine environments depending on your tech stack.'
    },
    {
      question: 'Do you handle domain transfers?',
      answer: 'Yes, we handle the entire migration process, including DNS management and domain records.'
    }
  ];

  return (
    <article className="website-page">
      <Hero 
        eyebrow="Deployment & Renewals"
        title={<>Managed <span className="hero-accent">Delivery</span> for the Cloud Era.</>}
        description="Launch with confidence. We manage the entire lifecycle of your web application from initial deployment to lifecycle renewals."
        primaryAction={{ label: "View Infrastructure", link: "#hosting" }}
        stats={[
          { label: "Deployment", value: "Fully Automated" },
          { label: "Security", value: "Auto-renewing SSL" }
        ]}
      />

      <section className="section" id="hosting">
        <div className="section-heading">
          <span className="eyebrow">The Stack</span>
          <h2>Reliable Launch Systems.</h2>
          <p>We ensure your web assets are hosted on the fastest clusters globally, with automated failover and 99.9% availability.</p>
        </div>
        <div className="features-grid">
          {features.map((f, i) => (
            <div key={i} className="feature-card">
              <div className="feature-icon">{f.icon}</div>
              <h3>{f.title}</h3>
              <p>{f.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section">
        <div className="info-row reverse">
          <div className="info-copy">
            <h3>Automated Operations</h3>
            <p>Our CI/CD pipelines ensure that updates are deployed smoothly without causing service interruptions to your users.</p>
            <ul className="check-list">
              <li><CheckCircle2 size={18} /> Zero-downtime deployments</li>
              <li><CheckCircle2 size={18} /> Managed DNS & CDN</li>
              <li><CheckCircle2 size={18} /> Auto-renewing certificates</li>
            </ul>
          </div>
          <div className="info-media">
            <img src="/images/deployment-renewals/deployment.jpg" alt="Deployment" />
          </div>
        </div>
      </section>

      <section className="section">
        <div className="section-heading">
          <span className="eyebrow">Deep Dive</span>
          <h2>Hosting & Operations.</h2>
        </div>
        <FAQ items={faqItems} />
      </section>

      <CTASection title="Let us handle the technical details." />
      <Footer />
    </article>
  );
}
